var replacePort = function (url, newPort) {
    var regex = /(https?:\/\/[^:/]+):(\d+)/;
    return url.replace(regex, "$1:".concat(newPort));
};
export { replacePort };
//# sourceMappingURL=replacePort.js.map